import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'

import API from './api'
import TraceStore from './syncing/traces'
import EventStore from './syncing/events'
import MarkerStore from './syncing/markers'
import AssessmentStore from './syncing/assessments'

import { deepFreeze } from '@/helpers'

import settingsStore from './settings'
import campaignStore from './campaign'
import environmentStore from './environment'
import deviceStore from './device'

import Tracer from '@/libraries/tracer'

const api = new API()
const traceStore = new TraceStore(api)
const eventStore = new EventStore(api)
const markerStore = new MarkerStore(api)
const assessmentStore = new AssessmentStore(api)

const restoreFrozen = (key, storage) => {
  const output = {}
  const entry = storage.getItem(key)
  if (!entry) return output

  const raw = JSON.parse(entry || '{}')
  for (const [key, value] of Object.entries(raw)) output[key] = deepFreeze(value)
  return output
}

const persistSettings = new VuexPersistence({ key: 'KampagnenTracker-Settings', modules: ['settings'] })
const environmentSettings = new VuexPersistence({ key: 'KampagnenTracker-Environment', modules: ['environment'], restoreState: restoreFrozen })

const store = createStore({
  getters: {
    isAuthenticated: () => api.isAuthenticated,
    traceStore: state => traceStore.setOptions({ syncRate: state.settings.syncRate, maxBadgeSize: state.settings.maxBadgeSize, deviceID: state.device.deviceID }),
    eventStore: state => eventStore.setOptions({ syncRate: state.settings.syncRate, maxBadgeSize: state.settings.maxBadgeSize, deviceID: state.device.deviceID }),
    markerStore: state => markerStore.setOptions({ syncRate: state.settings.syncRate, maxBadgeSize: state.settings.maxBadgeSize, deviceID: state.device.deviceID }),
    assessmentStore: state => assessmentStore.setOptions({ syncRate: state.settings.syncRate, maxBadgeSize: state.settings.maxBadgeSize, deviceID: state.device.deviceID })
  },
  actions: {
    init ({ dispatch }) {
      return Promise.all([
        dispatch('device/load')
      ])
    },
    getActive ({ state }) { return this.$api.getActive(state.device.deviceID) }
  },
  modules: {
    campaign: campaignStore,
    settings: settingsStore,
    environment: environmentStore,
    device: deviceStore
  },
  plugins: [persistSettings.plugin, environmentSettings.plugin]
})

store.$api = api
if (store.state.settings.instance && store.state.settings.key) api.authenticate(store.state.settings.instance, store.state.settings.key)

store.getTracer = additions => Object.freeze(new Tracer({
  getBattery: () => store.getters['device/battery'],
  getNetwork: () => store.state.device.networkType,
  traceRate: store.state.settings.traceRate,
  fields: store.state.environment.fields,
  additions
}))

export default store
